<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="기본정보" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-if="editable"
                  label="저장"
                  icon="save" />
                <c-btn
                  v-if="editable"
                  label="삭제"
                  icon="remove" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-3">
                <c-label-text title="TBM No" :value="data.col0"></c-label-text>
              </div>
              <div class="col-3">
                <c-label-text title="작업허가 No" :value="data.col1"></c-label-text>
              </div>
              <div class="col-3">
                <c-label-text title="공정명" :value="data.col2"></c-label-text>
              </div>
              <div class="col-3">
                <c-label-text title="회사명" :value="data.col3"></c-label-text>
              </div>
              <div class="col-3">
                <c-label-text title="작업명" :value="data.col4"></c-label-text>
              </div>
              <div class="col-3">
                <c-label-text title="작업책임자" :value="data.col5"></c-label-text>
              </div>
              <div class="col-3">
                <c-label-text title="작업일" :value="data.col6"></c-label-text>
              </div>
              <div class="col-3">
                <c-label-text title="작업장소" :value="data.col7"></c-label-text>
              </div>
              <div class="col-3">
                <c-label-text title="작업내용" :value="data.col8"></c-label-text>
              </div>
              <div class="col-3">
                <c-label-text title="사업장" :value="data.col9"></c-label-text>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
          <c-table
            ref="grid"
            title="위험요인 및 개선대책"
            tableId="grid"
            :columns="grid.columns"
            :data="grid.data"
            :usePaging="false"
            :hideBottom="true"
            :columnSetting="false"
            :isFullScreen="false"
            :filtering="false"
            :isExcelDown="false"
            selection="multiple"
            rowKey="col1"
            gridHeight="400px"
          >
            <template slot="table-button">
              <q-btn-group outline >
                <c-btn label="추가" icon="add" />
                <c-btn label="삭제" icon="remove" />
              </q-btn-group>
            </template>
          </c-table>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-table
            ref="grid"
            title="TBM 참석자"
            tableId="grid"
            :columns="grid2.columns"
            :data="grid2.data"
            :usePaging="false"
            :hideBottom="true"
            :columnSetting="false"
            :isFullScreen="false"
            :filtering="false"
            :isExcelDown="false"
            selection="multiple"
            rowKey="col1"
            gridHeight="400px"
          >
            <template slot="table-button">
              <q-btn-group outline >
                <c-btn label="추가" icon="add" />
                <c-btn label="삭제" icon="remove" />
              </q-btn-group>
            </template>
          </c-table>
        </div>
      </div>
    </q-form>
  </div>
</template>
<script>
// import selectConfig from '@/js/selectConfig';
// import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'daily-report-detail',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          title: '',
          psiDocumentId: '',
          documentClassCd: '',
        }
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      splitter: { data: 280 },
      tab: 'tab1',

      data: {
        col0: 'TBM2100652',
        col1: '2021-01393',
        col2: '기초공사',
        col3: '(주)아쿠아',
        col4: 'PCM(압연) 작업',
        col5: '김길동',
        col6: '2022-02-08',
        col7: '1공장 후문',
        col8: 'PCM(압연) 작업',
        col9: '1공장',
      },
      editable: false,
      grid: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '작업명',
            align: 'center',
            type: 'left',
            style: 'width:15%',
            sortable: false,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '작업단계',
            align: 'center',
            type: 'left',
            style: 'width:15%',
            sortable: false,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '위험요인',
            align: 'left',
            type: 'text',
            style: 'width:15%',
            sortable: false,
          },
          {
            name: 'col4',
            field: 'col4',
            label: '개선대책',
            align: 'left',
            type: 'text',
            style: 'width:55%',
            sortable: false,
          },
        ],
        data: [
          {
            col1: '고무라이닝 보수작업',
            col2: '자재운반',
            col3: '기계적(설비)요인 - 충돌위험부분',
            col4: '안전거리 확보',
          },
          {
            col1: '고무라이닝 보수작업',
            col2: '고무라이닝작업',
            col3: '기계적(설비)요인 - 추락위험부분(개구부 등)',
            col4: '안전거리 확보',
          },
          {
            col1: '고무라이닝 보수작업',
            col2: '자재정리',
            col3: '작업특성요인 - 질식위험, 산소결핍',
            col4: '산소호흡기 착용',
          },
          {
            col1: '고무라이닝 보수작업',
            col2: '작업종료',
            col3: '관리적요인 - 교육, 훈련부족',
            col4: '교육 실시',
          },
          {
            col1: '펌프교체작업',
            col2: '건조공정 작업단계',
            col3: '기계적(설비)요인 - 추락위험 부분(개구부 등)',
            col4: '관리자 지휘아래 단계적 작업 진행',
          },
          {
            col1: '베어링 하우징 교체',
            col2: '마감공정 작업단계',
            col3: '기계적(설비)요인 - 위험한 표면(절단, 베임, 긁힘)',
            col4: '단면 굴곡 평면화',
          },
        ],
      },
      grid2: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '근로자명',
            align: 'center',
            type: 'text',
            style: 'width:50%',
            sortable: false,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '직책/직무',
            align: 'center',
            type: 'text',
            style: 'width:50%',
            sortable: false,
          },
        ],
        data: [
          {
            col1: '김길동',
            col2: '1팀장',
          },
          {
            col1: '홍길동',
            col2: '1팀원',
          },
          {
            col1: '오길동',
            col2: '1팀원',
          },
          {
            col1: '정길동',
            col2: '1팀원',
          },
          {
            col1: '이길동',
            col2: '1팀원',
          },
        ],
      },
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 220);
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getData();
    },
    getData() {
    },
  }
};
</script>